import { render, staticRenderFns } from "./CounselingEdit.vue?vue&type=template&id=467ab000"
import script from "./CounselingEdit.vue?vue&type=script&lang=js"
export * from "./CounselingEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports